import type { ReactNode } from 'react';

export type BadgeTone = 'success' | 'error' | 'neutral' | 'brand';

const TONE_COLOR: Record<BadgeTone, string> = {
  success: 'var(--co-success)',
  error: 'var(--co-error)',
  neutral: 'var(--co-muted)',
  brand: 'var(--co-brand)',
};

interface Props {
  tone: BadgeTone;
  title?: string;
  children: ReactNode;
}

// Tinted pill, same treatment as CallbackLogs/StatusPill: the text color is a
// theme token and the background a color-mix of it, so nothing is hardcoded.
export function Badge({ tone, title, children }: Props) {
  const color = TONE_COLOR[tone];

  return (
    <span
      className="inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium"
      style={{ color, backgroundColor: `color-mix(in srgb, ${color} 12%, transparent)` }}
      {...(title ? { title } : {})}
    >
      {children}
    </span>
  );
}
